import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

const Index: React.FC<any> = ({ content }) => {
  const showContent = content.contentInfo['section-cta'];
  if (!showContent.title) {
    return null;
  }

  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{showContent.title}</h2>
      <p className={styles.desc}>{showContent.desc}</p>
      <ul className={styles.list}>
        {showContent.cards.map((item: any) => (
          <li key={item.title} className={styles.card}>
            <Link href={item.actionLabel} className={styles.cardLink}>
              <div>
                <Image src={item.imgPath} alt={item.title} width={20} height={20} className={styles.img} />
                <span>{item.title}</span>
              </div>
              <div>
                <div>{item.subTitle}</div>
                <div>{item.desc}</div>
              </div>

              <div style={{ color: '#000000' }}> {t('Explore Now')} →</div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Index;
